var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"id":"preViewIframe","src":_vm.fileUrl,"frameborder":"0","height":"500","width":"960"}})])}
var staticRenderFns = []

export { render, staticRenderFns }